import { render, staticRenderFns } from "./LinkForgottenPassword.vue?vue&type=template&id=69b17e38&"
import script from "./LinkForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./LinkForgottenPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69b17e38')) {
      api.createRecord('69b17e38', component.options)
    } else {
      api.reload('69b17e38', component.options)
    }
    module.hot.accept("./LinkForgottenPassword.vue?vue&type=template&id=69b17e38&", function () {
      api.rerender('69b17e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Auth/LinkForgottenPassword.vue"
export default component.exports